module.exports = __webpack_public_path__ + "static/media/icon_todos.d2128485.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_todos.svg
// module id = 526
// module chunks = 0